import axios from '../plugins/axios'

export default {
    copy(params){
      return axios.post('/api/v1/overlays/copy', params)
    }
}
